import httpClient from '@/api/http-client';

const endpoint = 'api/permit-scanner-locations';

const permitScannerLocationsService = {
  getAll: () => httpClient.get(endpoint),
};

export default permitScannerLocationsService;
